export enum IsModifiedOptionLabels {
  YES = 'Yes',
  NO = 'No',
}
